module.exports = __webpack_public_path__ + "media/images/maps/pins/pin1-6a28703fee52734ab47f2211d85d92e2.png";